/* src/app/components/discovery/production-job-details/production-job-details.component.scss */
mat-form-field {
  width: 100%;
}
mat-form-field:not(:has(textarea)) {
  --infix-height: 55px;
}
mat-toolbar.section-header {
  background: #f2f3f5;
}
.list {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.list .list-item {
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 18px;
}
.list .list-item .item-content {
  display: flex;
  gap: 8px;
  align-items: center;
}
.container {
  display: flex;
  justify-content: space-between;
  align-items: stretch;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 4px 12px 0px 12px;
}
.main-container {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  width: 100%;
  height: 100%;
}
.row-container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
  flex: 1;
}
.top-row {
  flex: 2;
}
.column {
  display: flex;
  flex-direction: column;
  flex-basis: 100%;
  flex: 1;
  margin: 2px 3px;
  min-width: 450px;
}
.mat-mdc-card {
  height: 100%;
}
.cell {
  width: 48%;
  padding-bottom: 3%;
  margin-bottom: 2%;
}
.cell-full-row {
  width: 100%;
}
.container:not(.read-only) {
  align-items: flex-end;
}
.container:not(.read-only) .cell.align-self-baseline {
  display: flex;
  align-self: baseline;
}
.production-is-processing-message {
  margin: 12px 22px 10px;
}
.title {
  font-size: 10px;
  color: rgba(0, 0, 0, 0.54);
  padding-bottom: 5px;
}
.info-text {
  padding-top: 2%;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.54);
}
.results-label {
  font-size: 12px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.54);
}
.mat-mdc-table {
  padding: 12px 24px;
  width: 100%;
}
.column-label {
  flex: 0 0 15% !important;
  width: 15% !important;
}
.column-produced {
  flex: 0 0 25% !important;
  width: 25% !important;
  justify-content: center;
}
.column-partially-privileged {
  flex: 0 0 25% !important;
  width: 25% !important;
  justify-content: center;
}
.column-withheld {
  flex: 0 0 25% !important;
  width: 25% !important;
  justify-content: center;
}
.column-total {
  flex: 0 0 10% !important;
  width: 10% !important;
  justify-content: center;
}
.panel-body {
  padding: 8px 16px 0px 16px;
}
:host-context(.dark-theme) .main-container .mat-mdc-card,
:host-context(.dark-theme) .main-container .mat-mdc-card-content,
:host-context(.dark-theme) .main-container .mat-mdc-table {
  background: #3f3f3f;
}
:host-context(.dark-theme) .main-container .mat-mdc-card .mat-toolbar {
  background: rgba(255, 255, 255, 0.0784313725);
}
:host-context(.dark-theme) .title,
:host-context(.dark-theme) .info-text,
:host-context(.dark-theme) .results-label {
  color: rgba(255, 255, 255, 0.6);
}
:host-context(.dark-theme) ::ng-deep ngx-skeleton-loader .loader {
  background-color: #414141;
}
/*# sourceMappingURL=production-job-details.component.css.map */
